module.exports = __webpack_public_path__ + "img/sound.728198bc.svg";